import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import Layout from "../../../Layouts/LayoutMain";
import Wizard from "../../../Components/Wizard/Wizard";
import CreateAccountForm from "../../../Components/Checkout/Forms/CreateAccountForm";
import DocuSign from "./DocuSign";
import { setGuestAlertStauts } from "../../../Store/Account/Actions";

class Lease extends Component {
    constructor(props) {
        super(props);

        const { setGuestAlertStauts } = props;

        setGuestAlertStauts(false);
    }

    componentWillUnmount() {
        const { setGuestAlertStauts } = this.props;

        setGuestAlertStauts(true);
    }

    render() {
        const { confirmPayment, userInfo } = this.props;

        if (userInfo.isGuest) {
            return (
                <Layout isAuthenticated={this.props.isAuthenticated}>
                    <Wizard
                        name="Lease"
                        submitAction={confirmPayment}
                        steps={[
                            { name: "leaseApplication.wizard.steps.zero.title", component: <CreateAccountForm wizardName="Lease" /> },
                            { name: "leaseApplication.wizard.steps.one.title", component: <DocuSign isWizard={true} wizardName="Lease" /> }
                        ]}
                    />
                </Layout>
            );
        } else {
            return (
                <Layout isAuthenticated={this.props.isAuthenticated}>
                    <DocuSign/>
                </Layout>
            );
        }
    }
}

Lease.propTypes = {
    setGuestAlertStauts: PropTypes.func,
    confirmPayment: PropTypes.func,
    userInfo: PropTypes.object,
    isAuthenticated: PropTypes.bool
};

function mapStateToProps(state) {
    return {
        userInfo: state.userInfo
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setGuestAlertStauts: setGuestAlertStauts
    }, dispatch)
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Lease));
